// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__37pGj","buttons":"SendReceipts_buttons__LnONR","email":"SendReceipts_email__39fQc","bookApptTitle":"SendReceipts_bookApptTitle__1e18Q"};